import axios from 'axios';
import cookies from 'js-cookie';

import { TOKEN_COOKIE_NAME } from '@/auth/constants';
import { Entities } from '@/types/entities';

/**
 * Получает список статусов, типов заявок, типов документов и типов тары
 */
export const getEntities = async (token?: string): Promise<Entities> => {
	token = token ?? cookies.get(TOKEN_COOKIE_NAME);

	const { data } = await axios.get<Entities>(`${process.env.HOST}/api_v1/entities/`, {
		headers: { Authorization: `Bearer ${token}` },
	});

	return data;
};
